import cloneDeep from 'lodash/cloneDeep'
import isPlainObject from 'lodash/isPlainObject'
import { Clearable } from '../models/Clearable'

/**
 * The type-appropriate "empty" counterpart of a value — the same rules
 * isEmptyValue checks against, applied to produce a blank value rather
 * than a boolean. Numbers, null, and Serializable/dayjs values pass through
 * unchanged: isEmptyValue never treats them as empty, so there is no
 * omit-from-URL ambiguity for them to resolve.
 */
export default function emptyValueLike(value: unknown): unknown {
  if (value instanceof Clearable) {
    const empty = cloneDeep(value)
    empty.clear()

    return empty
  }

  if (Array.isArray(value)) {
    return []
  }

  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, v]) => [key, emptyValueLike(v)]),
    )
  }

  if (typeof value === 'string') {
    return ''
  }

  if (typeof value === 'boolean') {
    return false
  }

  return value
}
